var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "py-1" },
    [
      _c(
        "v-card-title",
        { staticClass: "py-0" },
        [
          _c("div", { staticClass: "subheading font-weight-medium mr-2" }, [
            _vm._v("Filters"),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "border-secondary",
              attrs: {
                disabled: !_vm.hasFilter,
                small: "",
                color: "info",
                outline: "",
              },
              on: {
                click: function ($event) {
                  return _vm.clearFilters()
                },
              },
            },
            [
              _c("span", { staticClass: "text-capitalize" }, [
                _vm._v(_vm._s(_vm.$t("Button.Clear_Filters"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "list" } },
        _vm._l(_vm.filterTypes, function (filterType) {
          return _c(
            "v-card-text",
            {
              key: filterType.key,
              staticClass: "filter-type-layout mb-2 py-0",
              attrs: { row: "", grow: "" },
            },
            [
              filterType.filters.length > 0
                ? _c(
                    "v-layout",
                    [
                      _c("v-flex", { staticStyle: { flex: "0 0 150px" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "body-1 text-xs-right",
                            staticStyle: { "line-height": "32px" },
                          },
                          [_vm._v(_vm._s(filterType.label) + ":")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-2" },
                        _vm._l(filterType.filters, function (filter) {
                          return _c(
                            "v-chip",
                            {
                              key: filter.id,
                              attrs: { close: "", small: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.removeFilter(filter.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(filter) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }